<template>
  <LabelOutlined
    :label="label"
    :label_suffix="label_suffix"
    :is_disabled="is_disabled"
    :is_ready="!is_disabled"
    :width="width || '100%'"
    :dark="is_light_mode(getColor(foreground_color) || fg_fallback)"
    :background_color="getColor(background_color) || bg_fallback"
  >
    <template #content>
      <!-- INPUT -->
      <div class="ultra-disableable-input-field-container">
        <!-- ICON -->
        <TIcon
          v-if="icon"
          class="ultra-disableable-input-field-ticon"
          :name="icon"
          :color="getColor(foreground_color) || fg_fallback"
          small
        />

        <!-- EDITABLE TEXT -->
        <div
          v-if="!is_disabled"
          class="ultra-disableable-input-field-input"
        >
          <input
            :list="option_list?'option-list':''"
            :style="`
              color:${getColor(foreground_color) || fg_fallback};
              text-align: ${align || 'center'};
            `"
            :value="value"
            :id="focus_id"
            :type="input_type
              ? input_type
              : 'text'"
            :inputmode="input_mode"
            :placeholder="placeholder"
            @change="!is_live_emit ? emitChangeEvent($event): ''"
            @input="is_live_emit ? emitChangeEvent($event) : ''"
          />
          <datalist id="option-list" v-if="option_list">
            <option 
              v-for="option in option_list"
              :key="`option${option.value}`"
              :value="option.value"
              >
              {{ option.text }}
            </option>
          </datalist>
          
        </div>

        <!-- NON-EDITABLE TEXT -->
        <span
          v-else
          class="ultra-disableable-input-field-static-text"
          :style="`
            color:${getColor(foreground_color) || fg_fallback};
            text-align: ${align || 'center'};
            opacity:${!value && placeholder ? '.5' : ''};
          `"
        >
          {{ value ? value : value == 0 ? value : placeholder }}
        </span>
        <div
          class="ultra-disableable-input-field-unit"
          :style="`color: ${getColor(foreground_color) || fg_fallback}`"
        >
          {{ unit }}
        </div>
      </div>
    </template>
  </LabelOutlined>
</template>

<script>
import LabelOutlined from '@/components/WorkPackageWIP/LabelOutlined.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import { WorkPackageWIPMixin } from '@/mixins/WorkPackageWIPMixin.mixin.js';
import { TColor } from '@/mixins/TColor.mixin.js';

  export default {
    components: {
      LabelOutlined,
      TIcon,
    },

    mixins: [
      WorkPackageWIPMixin,
      TColor,
    ],

    // NOTE: if any member of an equation has a label, all members should have labels because of alignment issues
    props: [
      'label', // is string, label shown in top borde
      'label_suffix',
      'label_size', // is number, determins how big the label on top should be
      'icon', // is an optional icon (string) that is shown before the text
      'value', // is displayed text (string)
      'placeholder', // is displaced text (string) when no value is set
      'width', // is number, controls width of container. if not set defaults to 100%
      'is_disabled', // toggles if the text is editable or not (boolean)
      'align', // is string, modifys default text-align behaviour (center)
      'background_color', // is string, contains hexadecimal value of background
      'foreground_color', // is string, contains hexadecimal value of text, outlines etc.
      'input_type',
      'input_mode',
      'unit',
      'is_live_emit', // is boolean, controls wether search bar emits on every key change
      'option_list',
      'focus_id',
    ],

    computed: {
      bg_fallback() {
        return this.getColor("color-1");
      },

      fg_fallback() {
        return this.getColor();
      },
    },

    data: () => ({

    }),
    methods: {
      emitChangeEvent(event) {
        this.$emit('change', event.target.value);
        if (!this.is_live_emit){
          event.target.blur();
        }
          
      },
    }
  }
</script>

<style>
  .ultra-disableable-input-field-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: calc(100% - 4px); /* 100% - 2 * margin */
    height: 24px;
    margin: 0 2px;
    align-items: center;
    grid-gap: 8px;
    font-size: 10pt;
    font-weight: 300;
  }
  .ultra-disableable-input-field-ticon {
    flex-shrink: 0;
  }
  .ultra-disableable-input-field-input {
    display: flex;
    width: calc(100%);
  }
  .ultra-disableable-input-field-input > input {
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    /* text-align: center; */
  }
  .ultra-disableable-input-field-input > input:focus {
    outline: none;
  }
  .ultra-disableable-input-field-static-text {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .ultra-disableable-input-field-unit {
    opacity: 0.5;
    /* font-style: italic; */
  }
  input[type=number]::-webkit-outer-spin-button,
  input[type=number]::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }

  input[type=number] {
      -moz-appearance:textfield;
  }
</style>
